import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer style={{
      marginTop: "3rem",
      padding: "1rem",
      background: "#1B4D3E",
      color: "#fff"
    }}>
      <div className="container" style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Tagline */}
        <div style={{ 
          textAlign: "center", 
          marginBottom: "0.75rem",
          fontSize: "0.85rem",
          color: "#E8F5E9",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px"
        }}>
          <span>Made for the</span>
          <Heart size={14} fill="#E57373" color="#E57373" style={{ flexShrink: 0 }} />
          <span>of Mahjong</span>
        </div>
        
        {/* Work in Progress Notice */}
        <div style={{
          textAlign: "center",
          marginBottom: "0.75rem",
          fontSize: "0.7rem",
          color: "rgba(255,255,255,0.7)"
        }}>
          Work in progress. For help or feature requests, email{" "}
          <a href="mailto:contact@playmahjong.in" style={{ color: "#B2DFDB", fontWeight: "500" }}>
            contact@playmahjong.in
          </a>
        </div>

        {/* Links & Copyright on same line */}
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          gap: "1rem",
          flexWrap: "wrap",
          fontSize: "0.75rem"
        }}>
          <Link to="/about" style={{ color: "#B2DFDB", textDecoration: "none" }}>
            About
          </Link>
          <span style={{ color: "#80CBC4" }}>•</span>
          <Link to="/help" style={{ color: "#B2DFDB", textDecoration: "none" }}>
            Help
          </Link>
          <span style={{ color: "#80CBC4" }}>•</span>
          <Link to="/faq" style={{ color: "#B2DFDB", textDecoration: "none" }}>
            FAQ
          </Link>
          <span style={{ color: "#80CBC4" }}>•</span>
          <Link to="/terms" style={{ color: "#B2DFDB", textDecoration: "none" }}>
            Terms
          </Link>
          <span style={{ color: "#80CBC4" }}>•</span>
          <Link to="/privacy" style={{ color: "#B2DFDB", textDecoration: "none" }}>
            Privacy
          </Link>
          <span style={{ color: "#80CBC4" }}>•</span>
          <span style={{ color: "#80CBC4" }}>© 2026 PlayMahjong.in</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
